module.exports = __webpack_public_path__ + "img/user-guest.20708bae.png";